import { object } from "prop-types";
import { observer } from "mobx-react";
import { useDroppable } from "@dnd-kit/react";
import { useEstimateEditorSettings } from "@tools";
import { timelineCollisionDetection } from "@tools/EstimateEditor/utils/index";
import useStyle from "./TimelineExpandingComponent.style";
import classnames from "classnames";

export const TimelineExpandingDay = observer(({ day }) => {
  const classes = useStyle();
  const { allowEdition } = useEstimateEditorSettings();

  const { ref, isDropTarget } = useDroppable({
    id: `day-${day.getTime()}`,
    type: "day",
    data: { date: day },
    disabled: !allowEdition,
    collisionDetector: timelineCollisionDetection,
  })

  return (
    <div
      ref={ref}
      className={classnames(
        classes.body,
        classes.dayBody,
        isDropTarget && classes.isOver,
      )}
    />
  );
});

TimelineExpandingDay.propTypes = {
  day: object.isRequired,
};

TimelineExpandingDay.displayName = "TimelineExpandingDay";
